import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useSystemMaintenance } from "@/hooks/useSystemMaintenance";

interface SystemMaintenanceProviderProps {
  children: React.ReactNode;
}

export const SystemMaintenanceProvider = ({ children }: SystemMaintenanceProviderProps) => {
  const { user } = useAuth();
  const { autoCleanup } = useSystemMaintenance();

  // Executar limpeza automática uma vez por dia quando usuário estiver logado
  useEffect(() => {
    if (user) {
      // Aguardar um pouco para não impactar o carregamento inicial
      const timer = setTimeout(() => {
        autoCleanup();
      }, 5000); // 5 segundos após login

      return () => clearTimeout(timer);
    }
  }, [user, autoCleanup]);

  return <>{children}</>;
};